const createSite = {
  form: {
    header: {
      title: 'Olá,',
    },

    fields: {
      sitePlaceHolder: 'Por favor, preencha o nome do seu site',
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Que cenário gostaria de transmitir com a Moovex?',
        instructions: 'Por favor, verifique o campo que mais descreva a sua zona de trabalho.',
      },
    },

    button: 'PRECISO DETALHES',
  },
};

export default createSite;
